/*
 * @Author: 朱亚
 * @Date: 2020-10-10 10:19:09
 * @说明：路由配置，采用路由懒加载方式，来缓解首屏加载慢，达到按需加载
 * @懒加载：resolve => require(['组件地址'], resolve) 改成：  () => import('组件地址')
 */

import Vue from 'vue'
import Router from 'vue-router'

let routes = []

// 所有路由数据
let url = {
  // 默认进入授权页面
  '/': {
    filePath: 'bind/isBind',
    notNeedAuth: true
  },
  // 授权页面
  '/isBind': {
    filePath: 'bind/isBind',
    notNeedAuth: true
  },
  // 登录入口
  '/login': {
    filePath: 'bind/index',
    notNeedAuth: true
  },
  // ERP系统统一入口
  '/main': {
    filePath: 'main',
    children: {
      // 系统首页
      home_index: 'index',
      // 开新单
      open_newOrder: 'order/newOrder',
      // 订单扫条码
      order_scan: 'order/scan',
      // 订单中心-订单列表
      order_orderList: 'order/orderList',
      // 订单中心-订单详情
      order_orderDetail: 'order/orderDetail',
      // 订单中心-单个制作项绩效填写
      order_itemAchievements: 'order/itemAchievements',
      // 订单中心-订单绩效填写
      order_orderAchievements: 'order/orderAchievements',
      // 订单中心-订单收款
      order_orderCollect: 'order/orderCollect',
      // 客户中心-客户列表
      customer_cusList: 'customer/cusList',
      // 客户中心-添加客户
      customer_addCus: 'customer/addCus',
      // 客户中心-客户详情
      customer_cusDetail: 'customer/cusDetail',
      // 客户中心-历史订单
      customer_cusOrder: 'customer/cusOrder',
      // 客户详情-联系人
      customer_linkman: 'customer/cusLinkman',
      // 客户详情-添加联系人
      customer_addLinkman: 'customer/addLinkman',
      // 客户详情-客户收款记录
      customer_cusReceive: 'customer/cusReceive',
      // 客户中心-发票管理
      customer_invoice: 'customer/invoice',
      // 客户中心-短信提醒配置
      customer_smsConfig: 'customer/smsConfig',
      // 客户中心-充值
      customer_recharge: 'customer/cusRecharge',
      // 客户中心-添加客户扩展信息
      customer_addInfo: 'customer/addCusInfo',
      // 客户中心-结算方式
      customer_paymethod: 'customer/cusPaymethod',
      // 客户回访
      customer_visit: 'customer/visit',
      // 回访记录
      customer_visitRecord: 'customer/visitRecord',
      // 收款记录
      finance_receiveRecord: 'finance/receiveRecord',
      // 收款-收款详情
      finance_receiveDetail: 'finance/receiveDetail',
      // 销售报表
      finance_salesReport: 'finance/salesReport',
      // 系统-首页
      system_index: 'system/index',
      // 系统-产品价格
      product_productPrice: 'system/productPrice',
      // 系统-个人中心
      system_user: 'system/user',
      // 系统-个人中心-基本信息
      system_userInfo: 'system/userInfo',
      // 系统-个人中心-修改密码
      system_password: 'system/password',
      // 系统-应用中心
      system_application: 'system/applicationIndex',
      // 系统-功能服务购买
      system_functionBuy: 'system/functionBuy',
      // 系统-设置
      system_config: 'system/config',
      // 消息中心-列表
      notice_index: 'notice/index',
      // 消息中心-详情
      notice_detail: 'notice/detail',
      // 员工-列表
      hr_index: 'hr/index',
      // 员工-新建员工
      hr_addEmployee: 'hr/addEmployee'
    }
  },
  // ---- 企业微信统一入口 ----
  '/wxwork': {
    filePath: 'wxwork',
    // notNeedAuth: true,
    children: {
      // 客户画像
      customer_profile: 'wxwork/profile/index',
      // 客户列表
      customer_cusList: 'wxwork/profile/list',
      // 客户充值
      customer_recharge: 'wxwork/profile/cusRecharge',
      // 修改客户
      customer_editCus: 'wxwork/profile/editCus',
      // 添加客户
      customer_addCus: 'wxwork/profile/addCus',
      // 客户回访
      customer_visit: 'wxwork/profile/visit',
      // 回访记录
      customer_visitRecord: 'wxwork/profile/visitRecord',
      // 客户足迹
      customer_footmarksRecord: 'wxwork/profile/footmarksRecord',
      // 优惠券
      coupon_list: 'wxwork/coupon/index',
      // 营销工具
      sales_tools: 'wxwork/saletool/index',
      // 开新单
      open_newOrder: 'wxwork/order/newOrder',
      // 订单列表
      order_orderList: 'wxwork/order/orderList',
      // 订单详情
      order_orderDetail: 'wxwork/order/orderDetail',
      // 订单列表
      order_customerOrder: 'wxwork/order/customerOrders',
      // 订单收款
      order_orderCollect: 'wxwork/order/orderCollect',
      // 订单中心-单个制作项绩效填写
      order_itemAchievements: 'wxwork/order/itemAchievements',
      // 订单中心-订单绩效填写
      order_orderAchievements: 'wxwork/order/orderAchievements',
      // 订单扫条码
      order_scan: 'wxwork/order/scan',
      // 资源管理(案例库、话术)
      resource_index: 'wxwork/resource/index',
      // 新增话术
      resource_addScript: 'wxwork/resource/addScript'
    }
  }
}

for (let path in url) {
  let { filePath, notNeedAuth, wxNeedValidate, children } = url[path]
  let obj = {
    path,
    // component: resolve => require(['@/components/page/' + filePath], resolve)
    component: () => import('@/components/page/' + filePath)
  }
  if (notNeedAuth) obj.meta = { notNeedAuth }
  if (wxNeedValidate) obj.meta = { wxNeedValidate }
  if (children) {
    obj.children = []
    for (let c in children) {
      obj.children.push({
        path: c,
        // component: resolve => require(['@/components/page/' + children[c]], resolve)
        component: () => import('@/components/page/' + children[c])
      })
    }
  }
  routes.push(obj)
}
// console.log(routes)
Vue.use(Router)

// const originalPush = Router.prototype.push
// Router.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }

export default new Router({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes
})



// WEBPACK FOOTER //
// ./src/router/index.js